module.exports = __webpack_public_path__ + "img/11.2a55a62e.jpeg";